"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const utility_1 = require("../utility");
const types_1 = require("@voltmoney/types");
const context_1 = require("../context");
const react_native_1 = require("react-native");
const SharedPropsService_1 = __importDefault(require("../SharedPropsService"));
const PageRender_1 = __importDefault(require("./PageRender"));
const native_1 = require("@react-navigation/native");
const native_stack_1 = require("@react-navigation/native-stack");
const root_navigation_1 = require("../navigation/root_navigation");
const standardUtility_1 = require("../utility/standardUtility");
const lodash_1 = require("lodash");
const lottie_react_native_1 = __importDefault(require("lottie-react-native"));
const react_native_shimmer_placeholder_1 = require("react-native-shimmer-placeholder");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const Stack = (0, native_stack_1.createNativeStackNavigator)();
const isAndroid15 = react_native_1.Platform.OS === "android" && react_native_1.Platform.Version >= 35;
const MicroFrontend = ({ routeMap, routeCurrent, widgetRegistry, hasNotch, extraProps = {}, height = 0, width = 0, newHeight = 0, isPartnerPlatform }) => {
    var _a;
    const ShimmerPlaceholder = (0, react_native_shimmer_placeholder_1.createShimmerPlaceholder)(react_native_linear_gradient_1.default);
    let isDarkMode = null;
    let isFromTdl = false;
    if (react_native_1.Platform.OS === 'web') {
        let params = (0, utility_1.getParameters)((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href);
        isDarkMode = params.isDarkMode;
        isFromTdl = params.platform === "TATADIGITAL";
    }
    let phonePayRoutes = [standardUtility_1.ROUTE.EMAIL_VERIFY, standardUtility_1.ROUTE.PAN_CONFIRM_NAME, standardUtility_1.ROUTE.MF_FETCH_PORTFOLIO, standardUtility_1.ROUTE.MF_PLEDGE_PORTFOLIO, standardUtility_1.ROUTE.SET_CREDIT_LIMIT, standardUtility_1.ROUTE.CHECKING_LIMIT, standardUtility_1.ROUTE.KYC_PAN_VERIFICATION, standardUtility_1.ROUTE.UNLOCK_LIMIT_LANDING, standardUtility_1.ROUTE.PLEDGE_CONFIRMATION, standardUtility_1.ROUTE.PORTFOLIO, standardUtility_1.ROUTE.KFS_SCREEN, standardUtility_1.ROUTE.OTP_AUTH_CAS, standardUtility_1.ROUTE.UPDATE_SLIDER_AMOUNT, standardUtility_1.ROUTE.MODIFY_PLEDGED_AMOUNT, standardUtility_1.ROUTE.PORTFOLIO_FROM_RTA, standardUtility_1.ROUTE.JOINT_HOLDER_NOTIFY, standardUtility_1.ROUTE.UPDATE_PHONE_NUMBER, standardUtility_1.ROUTE.UPDATE_EMAIL_ID];
    const [isLoading, toggleLoad] = (0, react_1.useState)(false);
    const [loadingLottie, setLoadingLottie] = (0, react_1.useState)("");
    const { state, setRouteMap, setTemplateForRoute, setDataStoreInPath, appendWidgets, removeWidgets, } = (0, react_1.useContext)(context_1.Context);
    const standardUtilities = (0, react_1.useMemo)(() => (0, standardUtility_1.standardUtilitiesRaw)(state, setDataStoreInPath, appendWidgets, removeWidgets, routeCurrent, height, width), [state, height]);
    const _ShimmerReact = () => {
        return (react_1.default.createElement(react_native_1.View, { style: {
                width: '100%',
                height: '100%',
                flexDirection: 'column',
                padding: 16,
            } },
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: "column",
                    width: '100%',
                    height: '100%',
                    padding: 16,
                    backgroundColor: '#F9FAFB'
                } },
                react_1.default.createElement(ShimmerPlaceholder, { style: {
                        width: '100%',
                        borderRadius: 8,
                        height: 100
                    } }),
                react_1.default.createElement(ShimmerPlaceholder
                // stopAutoRun
                , { 
                    // stopAutoRun
                    style: {
                        width: '100%',
                        height: 100,
                        marginTop: 28,
                        borderRadius: 8,
                    } }),
                react_1.default.createElement(ShimmerPlaceholder
                // stopAutoRun
                , { 
                    // stopAutoRun
                    style: {
                        width: '100%',
                        height: 100,
                        marginTop: 28,
                        borderRadius: 8,
                    } }),
                react_1.default.createElement(ShimmerPlaceholder
                // stopAutoRun
                , { 
                    // stopAutoRun
                    style: {
                        width: '100%',
                        height: 100,
                        marginTop: 28,
                        borderRadius: 8,
                    } }),
                "  ",
                react_1.default.createElement(ShimmerPlaceholder
                // stopAutoRun
                , { 
                    // stopAutoRun
                    style: {
                        width: '100%',
                        height: 100,
                        marginTop: 28,
                        borderRadius: 8,
                    } }),
                "  ",
                react_1.default.createElement(ShimmerPlaceholder
                // stopAutoRun
                , { 
                    // stopAutoRun
                    style: {
                        width: '100%',
                        height: 100,
                        marginTop: 28,
                        borderRadius: 8,
                    } }),
                "  ",
                react_1.default.createElement(ShimmerPlaceholder
                // stopAutoRun
                , { 
                    // stopAutoRun
                    style: {
                        width: '100%',
                        height: 100,
                        marginTop: 28,
                        borderRadius: 8,
                    } }))));
    };
    let template = (state.routeMap != null &&
        state.routeMap[routeCurrent].template) ||
        null;
    let actions = (state.routeMap != null &&
        state.routeMap[routeCurrent].actions) ||
        null;
    let action = (state.routeMap != null &&
        state.routeMap[routeCurrent].action) ||
        null;
    let actionDelay = (state.routeMap != null &&
        state.routeMap[routeCurrent].actionDelay) ||
        0;
    let bgColor = (state.routeMap != null &&
        state.routeMap[routeCurrent].bgColor) ||
        'white';
    let clearPrevious = (state.routeMap != null &&
        state.routeMap[routeCurrent].clearPrevious) ||
        false;
    (0, react_1.useEffect)(() => {
        if (isFromTdl) {
            fetch("https://lottie.host/88fdfbca-7456-4f6f-8914-05defae77207/tuv0NJ73Lv.json", {
                method: "GET",
            })
                .then((response) => response.json())
                .then((responseData) => {
                console.log(responseData);
                setLoadingLottie(responseData);
            })
                .catch((error) => {
                console.log(error);
            });
        }
    }, []);
    /*** handle refresh on return to page if intentionally want to rebuild the page ***/
    const isFocused = (0, native_1.useIsFocused)();
    (0, react_1.useEffect)(() => {
        /***  Check if routeMap already set ***/
        if (state.routeMap == null) {
            (0, lodash_1.debounce)(_initGlobalProps, 16)();
        }
        /***  Reload on Coming Back to This Screen. ***/
        if (isFocused) {
            (0, lodash_1.debounce)(buildTemplate, 16)();
        }
    }, [isFocused]);
    const buildTemplate = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (clearPrevious) {
            template = null;
        }
        yield toggleLoad(true);
        console.info('*** ', routeCurrent, ' building...');
        try {
            const resolveOnLoad = yield routeMap[routeCurrent].onLoad(standardUtilities, extraProps);
            console.info('*** ', routeCurrent, ' build complete.');
            yield setTemplateForRoute({
                routeId: routeCurrent,
                template: resolveOnLoad,
            });
            yield toggleLoad(false);
        }
        catch (e) {
            console.info(`*** ${routeCurrent} build error ${e}`);
        }
    }), [clearPrevious, routeCurrent, extraProps]);
    const _initGlobalProps = () => __awaiter(void 0, void 0, void 0, function* () {
        /*** setting widget registry ***/
        yield SharedPropsService_1.default.setGlobalProps({
            widgetRegistry: widgetRegistry,
            ref: {},
            routeMap: routeMap,
        });
        /*** setting routeMap ***/
        yield setRouteMap(routeMap);
    });
    const PageRenderMemo = (0, react_1.useMemo)(() => {
        if (!template)
            return react_1.default.createElement(react_1.default.Fragment, null);
        return (react_1.default.createElement(PageRender_1.default, { routeId: routeCurrent, template: template, actions: actions, action: action, actionDelay: actionDelay, bgColor: bgColor, onEndReached: routeMap[routeCurrent].onEndReached, onRefresh: buildTemplate, extraProps: Object.assign(Object.assign({}, extraProps), { heightScreen: height, widthScreen: width }), isLoading: isLoading, heightScreen: height, widthScreen: width }));
    }, [template, height]);
    return (react_1.default.createElement(react_native_1.View, { style: {
            height: height,
            width: width,
            paddingVertical: react_native_1.Platform.OS === "ios" ? 10 : 0,
            backgroundColor: (template === null || template === void 0 ? void 0 : template.layout.type) === types_1.LAYOUTS.MODAL
                ? 'transparent'
                : isDarkMode && phonePayRoutes.includes(routeCurrent) ? '#0D141F' : 'white',
        } }, react_native_1.Platform.OS === 'web' ?
        react_1.default.createElement(react_1.default.Fragment, null, (isLoading && isPartnerPlatform) ? (react_1.default.createElement(react_1.default.Fragment, null, _ShimmerReact())) :
            react_1.default.createElement(react_1.default.Fragment, null,
                !isLoading && PageRenderMemo,
                isLoading && !isPartnerPlatform && (react_1.default.createElement(react_native_1.View, { style: {
                        flex: 1,
                        alignSelf: 'center',
                        position: 'absolute',
                        justifyContent: 'center',
                        alignItems: 'center',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                    } }, isFromTdl ? react_1.default.createElement(lottie_react_native_1.default, { source: loadingLottie, style: { width: 273, height: 378 }, autoPlay: true, loop: true }) : react_1.default.createElement(react_native_1.ActivityIndicator, { color: '#1434CB', size: 32 }))))) :
        react_1.default.createElement(react_1.default.Fragment, null,
            PageRenderMemo,
            isLoading && (react_1.default.createElement(react_native_1.View, { style: Object.assign(Object.assign({ flex: 1 }, react_native_1.Platform.OS !== 'ios' && { height: '100%' }), { backgroundColor: '#25252599', alignSelf: 'center', position: 'absolute', justifyContent: 'center', alignItems: 'center', top: 0, bottom: 0, left: 0, right: 0 }) },
                react_1.default.createElement(react_native_1.ActivityIndicator, { color: '#1434CB', size: 32 }))))));
};
const MicroFrontendWithNavigation = (props) => {
    const config = {
        screens: {},
    };
    Object.keys(props.routeMap).forEach((routeId) => {
        config.screens[`${routeId}`] = {
            path: `${routeId}/:params?`,
            exact: true,
        };
    });
    const paramsFromUrl = (0, utility_1.getParameters)((0, utility_1.getCurrentURL)());
    const renderMF = (0, react_1.useCallback)((nav, routeId) => {
        return (react_1.default.createElement(MicroFrontend, Object.assign({}, props, { routeCurrent: routeId }, (isAndroid15 ? { height: props.height } : {}), { extraProps: Object.assign(Object.assign(Object.assign(Object.assign({}, props.extraProps), nav.route.params), paramsFromUrl), { urlParams: (0, utility_1.getCurrentURL)() }) })));
    }, [props, paramsFromUrl, props.newHeight]);
    const StackScreen = (0, react_1.useMemo)(() => Object.keys(props.routeMap).map((routeId) => {
        return (react_1.default.createElement(Stack.Screen, { name: routeId, key: routeId, options: {
                presentation: react_native_1.Platform.OS === "ios" ? 'containedTransparentModal' : "transparentModal",
            } }, (navProps) => renderMF(navProps, routeId)));
    }), isAndroid15 ? [props.routeMap, props.height] : []);
    //@todo - remove this from platform
    /** [Toggle Navigation Linking Added to send notification to Android/iOS WebView Navigation Changes] **/
    const partnerPlatform = (0, utility_1.getCurrentURL)()
        .toLowerCase()
        .includes('partnerplatform');
    const platform = (0, utility_1.getCurrentURL)()
        .toLowerCase()
        .includes('platform');
    const params = (0, utility_1.getParameters)((0, utility_1.getCurrentURL)());
    const platformName = (params === null || params === void 0 ? void 0 : params.platform) || '';
    return (react_1.default.createElement(native_1.NavigationContainer, { independent: true, ref: root_navigation_1.navigationRef, documentTitle: {
            enabled: false,
        }, linking: {
            enabled: partnerPlatform &&
                platform &&
                platformName.includes('SDK_INVESTWELL'),
            prefixes: [
                'https://app.voltmoney.in',
                'voltmoney://',
                'http://localhost:3000',
            ],
            config,
            getPathFromState: (state, options) => {
                const endPoints = (0, native_1.getPathFromState)(state, options)
                    .toLowerCase()
                    .split('/')[1];
                const url = (0, utility_1.getCurrentURL)();
                const finalUrl = `${url}/${endPoints}`;
                return finalUrl;
            },
        } },
        react_1.default.createElement(Stack.Navigator, { screenOptions: {
                headerShown: false,
                statusBarTranslucent: true,
                animation: 'none'
            }, initialRouteName: props.routeCurrent }, StackScreen)));
};
const MicroFrontendWithContext = react_1.default.forwardRef((props, ref) => {
    return (
    // @ts-ignore
    react_1.default.createElement(context_1.Provider, { ref: ref },
        react_1.default.createElement(MicroFrontendWithNavigation, Object.assign({}, props))));
});
exports.default = (0, react_1.memo)(MicroFrontendWithContext, (0, utility_1.arePropsEqual)([
    'routeCurrent',
    'routeMap',
    'extraProps'
]));
//# sourceMappingURL=MicroFrontend.js.map